module.exports = __webpack_public_path__ + "img/logo.b8b1a2b0.png";